<template lang="pug">
	div.container-fluid
		.row
			.col-xs-12.col-sm-12.col-md-4.col-lg-3.col-xl-3
				.card
					.card-header.bg-info.text-white
						span.fa.fa-cubes.mr-2
						| Contenidos
					.card-body
						.form-group
							label Emisora
							select.form-control(v-model="filtro.emisora_ID", @change="buscar")
								option(:value="null") Genéricos
								option(
									v-for="emisora in listadoEmisoras"
									:key="emisora.ID_emisora"
									:value="emisora.ID_emisora"
								) {{emisora.nombre}}
						.form-group
							label Nombre
							input.form-control(v-model="filtro.nombre", @keypress.enter="buscar")
						.form-group
							label Estado
							br
							.btn-group
								button.btn(:class="(filtro.activo === null) ? 'btn-primary' : ''", @click="filtraEstado(null)") Todos
								button.btn(:class="(filtro.activo === true) ? 'btn-success' : ''", @click="filtraEstado(true)") Activos
								button.btn(:class="(filtro.activo === false) ? 'btn-danger' : ''", @click="filtraEstado(false)") Inactivos
					.card-footer
						button.btn.btn-primary(@click="nuevo")
							span.fa.fa-plus.mr-2
							| Nuevo
			.col-xs-12.col-sm-12.col-md-8.col-lg-9.col-xl-9
				.card
					.card-header.bg-warning
						span.fa.fa-list.mr-2
						| Listado de contenidos
					.table-responsive
						table.table.table-striped.m-0
							thead.bg-dark.text-white
								tr
									th Nombre
									th Horas
									th Días de la semana
									th
							tbody
								tr(v-for="c in listadoContenidos", :key="c.ID_contenido")
									td.p-1.pl-3(style="vertical-align:middle;") {{c.nombre}}
									td.p-1(style="vertical-align:middle;") {{c.hora_inicio}} - {{c.hora_fin}}
									td.p-1(style="vertical-align:middle;")
										span.m-1(v-for="d in c.dias_semana") {{dias[d]}}
									td.p-1.pr-3.text-right(style="vertical-align:middle;")
										button.btn.btn-primary.m-1(@click="ID_contenido = c.ID_contenido")
											span.fa.fa-edit
										button.btn.btn-danger.m-1(@click="del(c.ID_contenido)")
											span.fa.fa-trash
							tbody(v-if="listadoContenidos.length === 0")
								tr
									td.text-danger.p-4.text-center(colspan="4")
										span.fa.fa-info-circle.m-3(style="font-size:3em;")
										br
										h3 No hay contenidos
		editor-contenidos(v-if="ID_contenido", :id-contenido="ID_contenido", @cerrar="cierraEditor")
</template>

<script>
import EditorContenidos from './editor-contenidos'
export default {
	components: {
		'editor-contenidos': EditorContenidos
	},
	data () {
		return {
			filtro: {
				emisora_ID: null,
				activo: true,
				nombre: null
			},
			ID_contenido: null,
			listadoEmisoras: [],
			listadoContenidos: [],
			dias: ['L', 'M', 'X', 'J', 'V', 'S', 'D']
		}
	},
	created () {
		this.$http.post('gestion-emisoras/php/api/emisoras/buscar-emisoras.php', {activa: true})
			.then(res => {
				this.listadoEmisoras = res.data.listado
			})
			.catch(this.$responseError)

		this.buscar()
	},

	methods: {
		cierraEditor () {
			this.ID_contenido = null
			this.buscar()
		},
		buscar () {
			this.$http.post('gestion-emisoras/php/api/contenidos/buscar-contenidos.php', this.filtro)
				.then(res => {
					this.listadoContenidos = res.data.listado
				})
				.catch(this.$responseError)
		},
		filtraEstado (estado) {
			this.filtro.activo = estado
			this.buscar()
		},
		nuevo () {
			this.ID_contenido = 'nuevo'
		},
		del (idContenido) {
			this.$store.commit('alertas/confirm', {
				titulo: 'Eliminar contenido',
				mensaje: `¿Estás seguro de que quieres eliminar este contenido?
				En ocasiones es mejor marcarlo como inactivo ya que así las inserciones asociadas a él no se quedarán huérfanas.
				¿Quieres continuar y eliminarlo?`,
				callback: acepta => {
					if (acepta) {
						this.$http.delete('gestion-emisoras/php/api/contenidos/del-contenido.php?ID_contenido=' + idContenido)
							.then(res => {
								this.$store.commit('toast/danger', {
									titulo: 'Eliminado',
									mensaje: 'Se ha eliminado el contenido correctamente'
								})
								this.buscar()
							})
							.catch(this.$responseError)
					}
				}
			})
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/gestion-emisoras/vue/componentes/contenidos/contenidos.vue